import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_12: FaireProductEntity = {
  token: "atc_updated_moma_12",
  type: "product",
  name: "Double-Wall Glass Tea Mug",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4bdffa881e93d3867f1994832a9c52bfe1a5b66f26f09c299187401b4328252d.webp",
  priceDollars: 32,
  msrpDollars: 40,
  description: "With infuser and lid.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
